import { Trans } from 'gatsby-plugin-react-i18next';
import { clamp } from 'ramda';
import React, {  useRef } from 'react';
import { animated, useSprings } from 'react-spring';
import { useGesture } from 'react-use-gesture';
import { css } from 'twin.macro';
import { convertToPx } from 'utils/helper';

const defaultItems = [
	{ title: <Trans i18nKey="pageSupplier.howItWork.title.1" />, desc: <Trans i18nKey="pageSupplier.howItWork.desc.1" /> },
	{ title: <Trans i18nKey="pageSupplier.howItWork.title.2" />, desc: <Trans i18nKey="pageSupplier.howItWork.desc.2" /> },
];

const cssCarouselList = css`
  position: relative;
  justify-content: center;
  display: flex;
  height: 14rem;
  margin-top: 1rem;

  .carousel-container {
    overscroll-behavior-y: contain;
    height: 100%;
    width: 100%;
    user-select: none;
    position: absolute;
    overflow: hidden;
    bottom: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .wrapper {
    will-change: transform;
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .item {
    box-shadow: inset 0 0 0 1px var(--color-main);
    border-radius: 1rem;
    margin: auto;
    width: 75%;
  }
`;

export default function CarouselList({ data = defaultItems }) {
	const index = useRef(0);
	const ITEM_WIDTH = convertToPx(21);

	const [props, set] = useSprings(data.length, i => ({ x: i * ITEM_WIDTH, sc: 1, display: 'block' }));

	const bind = useGesture({
		onDrag: ({ down, direction: [xDir], distance, cancel }) => {
			if (down && distance > ITEM_WIDTH / 3) {
				index.current = clamp(0, data.length - 1, index.current + (xDir > 0 ? -1 : 1));
				cancel();
			}

			set((i) => {
				if (i < index.current - 1 || i > index.current + 1) return { display: 'none' };
				const x = (i - index.current) * ITEM_WIDTH + (down ? xDir*distance : 0);
				const sc = down ? 1 - distance / ITEM_WIDTH / 2 : 1;
				return { x, sc, display: 'block' };
			});
		}
	});

	return (
		<div css={[ cssCarouselList ]}>
			<div className='carousel-container'>
				{props.map(({ x, display, sc }, i) => (
					<animated.div {...bind()} className='wrapper' key={i} style={{ display, transform: x.interpolate(x => `translate3d(${x}px,0,0)`) }}>
						<animated.div className='item' style={{ transform: sc.interpolate(s => `scale(${s})`) }}>
							<div className='w-full h-full border border-grey-E rounded-10'>
								<div className='relative rounded-10 px-10 py-10'>
									<div className='text-green-1 font-bold absolute top-0 bg-light h-15 -mt-07 w-80'>{data[i].title}</div>
									<div>{data[i].desc}</div>
								</div>
							</div>
						</animated.div>
					</animated.div>
				))}
			</div>
		</div>
	);
}
